export enum DeferredTypeEnum {
  InstallmentMerchant = "03",
}
